'use strict';

var resourceList = {
  /**
   * Aggregates all of the resources for easy access
   */
  Annotation          : require('./resources/annotation/AnnotationResource'),
  AnnotationLayer     : require('./resources/annotationLayer/AnnotationLayerResource'),
  DataCapture         : require('./resources/dataCapture/DataCaptureResource'),
  DataExport          : require('./resources/dataExport/DataExportResource'),
  DataSet             : require('./resources/dataSet/DataSetResource'),
  Overlay             : require('./resources/overlay/OverlayResource'),
  Site                : require('./resources/site/SiteResource'),
  SiteCCRS            : require('./resources/site/SiteCCRSResource'),
  Measurement         : require('./resources/measurement/MeasurementResource'),

  // User related resources
  User                : require('./resources/user/UserResource'),
  Project             : require('./resources/project/ProjectResource'),
  ProjectUser         : require('./resources/project/ProjectUserResource'),
  Group               : require('./resources/group/GroupResource'),
  Invitation          : require('./resources/organization/InvitationResource'),
  Organization        : require('./resources/organization/OrganizationResource'),
  OrganizationUser    : require('./resources/organization/OrganizationUserResource'),
  OrganizationProject : require('./resources/organization/OrganizationProjectResource'),
  Plan                : require('./resources/plan/PlanResource'),
  ProcessingJob       : require('./resources/processingJob/ProcessingJobResource')
};

var initializedResources = {};

// Module is initialized as a service, so it will be injected the DataStore
// as a dependency.
var Resources = function(DS) {

  this.initialize = function(resourceName, options) {
    var _resource = resourceList[resourceName];
    if(!_resource) {
      throw new Error('Resource ' + resourceName + ' is not specified');
    }
    if(initializedResources[resourceName]) {
      throw new Error('Resource ' + resourceName + ' has already been initialized');
    }
    /* jshint newcap: false */
    initializedResources[resourceName] = (new _resource(DS)).initialize(options);
  };

  this.getResource = function(resourceName) {
    if(!resourceList[resourceName]) {
      throw new Error('Resource ' + resourceName + ' is not specified');
    }
    var resource = initializedResources[resourceName];
    if(!resource) {
      throw new Error('Resource ' + resourceName + ' has not been initialized');
    }
    return resource;
  };
};

module.exports = Resources;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/data/src/ResourceHelper.js